import type { ChangeEvent } from 'react';
import { Controller, useForm } from 'react-hook-form';

import { useTranslate } from 'hooks';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { setComment } from 'store/payment/slice';
import { TextArea } from 'views/components/base/ui/text-area';

const DescriptionField = ({ isMobile }: { isMobile?: boolean }) => {
  const { t } = useTranslate();
  const { comment, paymentData } = useAppSelector((state) => state.payment);
  const { control, setValue } = useForm({
    mode: 'onChange',
  });
  const dispatch = useAppDispatch();

  const handleChangeComment = (e: ChangeEvent<HTMLTextAreaElement>) => {
    const { value } = e.target;

    if (paymentData) {
      setValue('description', value, { shouldValidate: paymentData.requiredDescription });
      dispatch(setComment(value));
    }
  };

  return paymentData ? (
    <form className="w-full md:max-w-none">
      <Controller
        name="description"
        control={control}
        rules={{
          required: 'Поле обязательно к заполнению',
          validate: (value) => {
            if (value.length < 1) {
              return 'Поле обязательно к заполнению';
            }

            return true;
          },
        }}
        defaultValue=""
        render={({ fieldState: { error } }) => (
          <TextArea
            name="description"
            value={comment}
            isMobile={isMobile}
            onChange={handleChangeComment}
            label={paymentData?.placeholder ? paymentData?.placeholder : t('comment')}
            upperLabel
            required={paymentData?.requiredDescription}
            inputClassName="text-left md:max-w-none overflow-hidden"
            placeholder={t('1xbet.input.comment.placeholder')}
            error={error?.message}
          />
        )}
      />
    </form>
  ) : null;
};

export { DescriptionField };
